import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyle = createStyles((theme: MantineTheme) => ({
  modalTitle: {
    fontWeight: 500,
    fontSize: "16px",
    padding: "7px",
  },
  modalHeader: {
    backgroundColor: "#ffffffff",
  },
  firstLineDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: "8px",
    textAlign: "left",
  },
  secLineDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: "16px",
    textAlign: "left",
  },
  buttonDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
  button: {
    backgroundColor: "rgba(51, 143, 134, 1)",
    width: "100%",
  },
}));
